import React, { useState, useEffect, useMemo } from 'react';
import { useHistory } from 'react-router-dom';

import apiClient from '../../_utils/axios';
import Store from 'store';
import { ContentsWrap } from '../Common';
import { BlockMore, BoxInImage, NoticeBar } from '../HomePage';
import { getCurrentLang } from '../../libs/lang';

export const Notice = ({}) => {
  const [data, setData] = useState([]);
  const history = useHistory();

  const getNoticeList = async () => {
    try {
      let res;
      const lang = getCurrentLang();
      switch (lang) {
        case 'kr':
          res = await apiClient.get(`/web/board?page=1&size=5&type=notice&lang=ko`);
          break;
        case 'en':
          res = await apiClient.get(`/web/board?page=1&size=5&type=notice&lang=en`);
          break;
        case 'jp':
          res = await apiClient.get(`/web/board?page=1&size=5&type=notice&lang=jp`);
          break;
        default: 
          res = await apiClient.get(`/web/board?page=1&size=5&type=notice&lang=en`);
      }
      if (res) {
        setData(res.data.data);
      }
    } catch (error) {
      console.error('Failed to fetch new design list:', error);
    }
  };

  useEffect(() => {
    getNoticeList();
  }, []); // Runs once when the component mounts

  const goNotice = (id) => {
    history.push(`/notices/view/${id}`);
  };

  return (
    <ContentsWrap>
      <div style={{ marginTop: '3vw', marginBottom: '2vw' }}>
        <NoticeBar
          content={data.length > 0 && data[0].title}
          time={data.length > 0 && data[0].datetime.substring(0, 10).replace(/-/gi, '.')}
          onClick={() => goNotice(data[0].id)}
        />
      </div>
    </ContentsWrap>
  );
};

export default Notice;
